exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.highlight {\n  color: #557CEF;\n}", ""]);

// exports
